// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#home-container .body-block {
  height: calc(100vh - 90px);
  display: flex;
  align-items: center;
}

.inputStyle input {
  width: 100%;
  outline: none;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  height: 50px;
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.inputStyle input:disabled {
  background-color: var(--ffff);
}

.t-input-icon {
  position: absolute;
  right: 18px;
  top: 18px;
  display: flex;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;AAAJ;;AAIE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAEI;EACE,6BAAA;AAAN;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AAFF","sourcesContent":["#home-container {\r\n  .body-block {\r\n    height: calc(100vh - 90px);\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n.inputStyle {\r\n  input {\r\n    width: 100%;\r\n    outline: none;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border: 1px solid var(--dee3);\r\n    border-radius: 8px;\r\n    height: 50px;\r\n    padding: 13px 16px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    font-family: \"f-400\";\r\n    line-height: 19.5px;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    &:disabled {\r\n      background-color: var(--ffff);\r\n    }\r\n  }\r\n}\r\n\r\n.t-input-icon {\r\n  position: absolute;\r\n  right: 18px;\r\n  top: 18px;\r\n  display: flex;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
